/* eslint-disable canonical/filename-match-exported -- FIXME: Fix this ESLint violation! */
import config from '@src/config'
import type {
  GetPublicApiKeysResponse,
  CreatePublicApiKeyResponse,
} from '@src/service/dto/response/PublicApiKeys'

import type Transport from '.'
import { HttpTransaction } from './transaction'

export default class AuthClient {
  constructor(private transport: Transport) {}

  api = {
    list: (): Promise<GetPublicApiKeysResponse> => {
      return this.transport.queue(
        new HttpTransaction({
          method: 'get',
          url: `${config.AUTH_SERVICE_URL}public-api/keys`,
        }),
      )
    },

    create: (label: string): Promise<CreatePublicApiKeyResponse> => {
      return this.transport.queue(
        new HttpTransaction({
          method: 'post',
          url: `${config.AUTH_SERVICE_URL}public-api/keys`,
          body: { label },
        }),
      )
    },

    delete: (id: string): Promise<void> => {
      return this.transport.queue(
        new HttpTransaction({
          method: 'delete',
          url: `${config.AUTH_SERVICE_URL}public-api/keys/${id}`,
        }),
      )
    },
  }

  setPassword(password: string): Promise<void> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'post',
        url: `${config.AUTH_SERVICE_URL}password`,
        body: { password },
      }),
    )
  }

  changePassword(oldPassword: string, password: string): Promise<void> {
    return this.transport.queue(
      new HttpTransaction({
        method: 'put',
        url: `${config.AUTH_SERVICE_URL}password`,
        body: { oldPassword, password },
      }),
    )
  }

  changeEmail(email: string) {
    return this.transport.queue(
      new HttpTransaction({
        method: 'post',
        url: `${config.AUTH_SERVICE_URL}email/sendCode`,
        body: { email },
      }),
    )
  }

  verifyChangeEmail(email: string, code: string) {
    return this.transport.queue(
      new HttpTransaction({
        method: 'patch',
        url: `${config.AUTH_SERVICE_URL}email/verify`,
        body: { email, code },
      }),
    )
  }
}
